export const learners = [
  {
    id: "L001",
    firstName: "Sarah",
    lastName: "Jenkins",
    email: "s.jenkins@company.com",
    jobTitle: "Senior Engineer",
    department: "Engineering",
    manager: "Tom Harris",
    location: "New York, US",
    employmentStatus: "Full Time",
    trainingStatus: "Compliant",
    phishingRiskScore: 12,
    lastTrainingDate: "Nov 15, 2024",
    lastPhishingResult: "Reported",
  },
  {
    id: "L002",
    firstName: "Michael",
    lastName: "Chang",
    email: "m.chang@company.com",
    jobTitle: "Account Executive",
    department: "Sales",
    manager: "Rachel Green",
    location: "Chicago, US",
    employmentStatus: "Full Time",
    trainingStatus: "Overdue",
    phishingRiskScore: 45,
    lastTrainingDate: "Aug 03, 2024",
    lastPhishingResult: "Clicked",
  },
  {
    id: "L003",
    firstName: "David",
    lastName: "Rodriguez",
    email: "d.rodriguez@company.com",
    jobTitle: "Financial Analyst",
    department: "Finance",
    manager: "Lisa Nguyen",
    location: "Remote",
    employmentStatus: "Full Time",
    trainingStatus: "Compliant",
    phishingRiskScore: 8,
    lastTrainingDate: "Dec 01, 2024",
    lastPhishingResult: "Reported",
  },
  {
    id: "L004",
    firstName: "Emma",
    lastName: "Wilson",
    email: "e.wilson@company.com",
    jobTitle: "Marketing Manager",
    department: "Marketing",
    manager: "Rachel Green",
    location: "Austin, US",
    employmentStatus: "Full Time",
    trainingStatus: "At Risk",
    phishingRiskScore: 82,
    lastTrainingDate: "Jul 20, 2024",
    lastPhishingResult: "Submitted",
  },
  {
    id: "L005",
    firstName: "James",
    lastName: "Smith",
    email: "j.smith@company.com",
    jobTitle: "HR Director",
    department: "HR",
    manager: "Tom Harris",
    location: "New York, US",
    employmentStatus: "Full Time",
    trainingStatus: "In Progress",
    phishingRiskScore: 22,
    lastTrainingDate: "Oct 12, 2024",
    lastPhishingResult: "Opened",
  },
  {
    id: "L006",
    firstName: "Priya",
    lastName: "Patel",
    email: "p.patel@company.com",
    jobTitle: "Security Engineer",
    department: "Engineering",
    manager: "Tom Harris",
    location: "San Francisco, US",
    employmentStatus: "Full Time",
    trainingStatus: "Compliant",
    phishingRiskScore: 4,
    lastTrainingDate: "Dec 10, 2024",
    lastPhishingResult: "Reported",
  },
  {
    id: "L007",
    firstName: "Carlos",
    lastName: "Mendes",
    email: "c.mendes@company.com",
    jobTitle: "Legal Counsel",
    department: "Legal",
    manager: "Lisa Nguyen",
    location: "Chicago, US",
    employmentStatus: "Contractor",
    trainingStatus: "Not Started",
    phishingRiskScore: 55,
    lastTrainingDate: null,
    lastPhishingResult: "No Data",
  },
  {
    id: "L008",
    firstName: "Aisha",
    lastName: "Okonkwo",
    email: "a.okonkwo@company.com",
    jobTitle: "Support Specialist",
    department: "Customer Support",
    manager: "Rachel Green",
    location: "Remote",
    employmentStatus: "Part Time",
    trainingStatus: "Overdue",
    phishingRiskScore: 38,
    lastTrainingDate: "Jun 30, 2024",
    lastPhishingResult: "Clicked",
  },
];